import { Vue, Component, Prop } from 'vue-property-decorator'
import Article from '~/types/api/news/Article'
import NewsItem from '~/components/block/NewsItem'

@Component
export default class NewsList extends Vue {
  @Prop({ required: true, type: Array })
  readonly items!: Article[]

  render () {
    return (
      <div class="news-list">
        <div class="news-list__row">
          {this.items.map(e => (
            <div class="news-list__row-item">
              <NewsItem {...{
                props: {
                  article: e
                }
              }} />
            </div>
          ))}
        </div>
      </div>
    )
  }
}
